/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContractStatusEnum } from './APIContractStatusEnum';
import {
    APIContractStatusEnumFromJSON,
    APIContractStatusEnumFromJSONTyped,
    APIContractStatusEnumToJSON,
} from './APIContractStatusEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContract
 */
export interface APIContract {
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    readonly rootAccountName: string;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    offer: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContract
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    readonly files: string;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    shippingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    billingAddress?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIContract
     */
    desiredDelivery?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIContract
     */
    latestDelivery?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIContract
     */
    priorityShipping?: boolean;
    /**
     * 
     * @type {APIContractStatusEnum}
     * @memberof APIContract
     */
    contractStatus?: APIContractStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof APIContract
     */
    comment?: string | null;
    /**
     * Price that gets selected by the user from the Prices of the Offer. Format: {'200': '123.45'}
     * @type {{ [key: string]: any; }}
     * @memberof APIContract
     */
    price?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof APIContract
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIContract
     */
    readonly article: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIContract
     */
    readonly request: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof APIContract
     */
    readonly read: boolean;
}



/**
 * Check if a given object implements the APIContract interface.
 */
export function instanceOfAPIContract(value: object): value is APIContract {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('rootAccountName' in value) || value['rootAccountName'] === undefined) return false;
    if (!('offer' in value) || value['offer'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('request' in value) || value['request'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    return true;
}

export function APIContractFromJSON(json: any): APIContract {
    return APIContractFromJSONTyped(json, false);
}

export function APIContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContract {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'rootAccountName': json['root_account_name'],
        'offer': json['offer'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'files': json['files'],
        'shippingAddress': json['shipping_address'] == null ? undefined : json['shipping_address'],
        'billingAddress': json['billing_address'] == null ? undefined : json['billing_address'],
        'desiredDelivery': json['desired_delivery'] == null ? undefined : (new Date(json['desired_delivery'])),
        'latestDelivery': json['latest_delivery'] == null ? undefined : (new Date(json['latest_delivery'])),
        'priorityShipping': json['priority_shipping'] == null ? undefined : json['priority_shipping'],
        'contractStatus': json['contract_status'] == null ? undefined : APIContractStatusEnumFromJSON(json['contract_status']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'price': json['price'] == null ? undefined : json['price'],
        'createdAt': (new Date(json['created_at'])),
        'article': json['article'],
        'request': json['request'],
        'read': json['read'],
    };
}

export function APIContractToJSON(value?: Omit<APIContract, 'self'|'root_account_name'|'files'|'created_at'|'article'|'request'|'read'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'offer': value['offer'],
        'editors': value['editors'],
        'shipping_address': value['shippingAddress'],
        'billing_address': value['billingAddress'],
        'desired_delivery': value['desiredDelivery'] == null ? undefined : ((value['desiredDelivery']).toISOString()),
        'latest_delivery': value['latestDelivery'] == null ? undefined : ((value['latestDelivery']).toISOString()),
        'priority_shipping': value['priorityShipping'],
        'contract_status': APIContractStatusEnumToJSON(value['contractStatus']),
        'comment': value['comment'],
        'price': value['price'],
    };
}

